

export enum BankRoles {
  ADMIN_BANK = 'Administrador Banco',
  ACCESS_MANAGER = 'Gerenciador de Acessos', 
  BANK_OPERATIONAL = 'Operacional Banco',
  CONSULTANT = 'Consulente',
  ANTI_FRAUD = 'Anti-Fraude',
  ENG_MANAGEMENT = 'Engenharia Gestão e Operação'
}

export enum ProviderRoles {
  REPORT_ANALYST = 'Analista de Laudos',
  MASTER_PROVIDER = 'Master Prestadora',
  PROVIDER_OPERATIONAL = 'Operacional Prestadora'
}

export enum InspectorRoles {
  INSPECTOR = 'Inspetor'
}

export type UserRole = BankRoles | ProviderRoles | InspectorRoles;

export const AllRoles = {
  ...BankRoles,
  ...ProviderRoles,
  ...InspectorRoles
} as const;

export const RolesByModule = {
  bank: Object.values(BankRoles) as UserRole[],
  provider: Object.values(ProviderRoles) as UserRole[],
  inspector: Object.values(InspectorRoles) as UserRole[]
} as const;

export function isRoleFromModule(role: UserRole, module: keyof typeof RolesByModule): boolean {
  return RolesByModule[module].includes(role as any);
}

export const RoleLabels: Record<UserRole, string> = {
  [BankRoles.ADMIN_BANK]: 'Administrador do Banco',
  [BankRoles.ACCESS_MANAGER]: 'Gerenciador de Acessos',
  [BankRoles.BANK_OPERATIONAL]: 'Operacional do Banco',
  [BankRoles.CONSULTANT]: 'Consulente',
  [BankRoles.ANTI_FRAUD]: 'Anti-Fraude',
  [BankRoles.ENG_MANAGEMENT]: 'Engenharia Gestão e Operação',
  
  [ProviderRoles.REPORT_ANALYST]: 'Analista de Laudos',
  [ProviderRoles.MASTER_PROVIDER]: 'Master Prestadora',
  [ProviderRoles.PROVIDER_OPERATIONAL]: 'Operacional Prestadora',
  
  [InspectorRoles.INSPECTOR]: 'Inspetor'
};

export const RoleDescriptions: Record<UserRole, string> = {
  [BankRoles.ADMIN_BANK]: 'Acesso completo a todas as funcionalidades do sistema',
  [BankRoles.ACCESS_MANAGER]: 'Gerencia usuários do banco e cria inspetores',
  [BankRoles.BANK_OPERATIONAL]: 'Acompanha inspeções, agendamentos, edita dados/documentos',
  [BankRoles.CONSULTANT]: 'Acesso apenas de leitura sem exportação',
  [BankRoles.ANTI_FRAUD]: 'Revisa laudos finalizados (não relatórios em andamento)',
  [BankRoles.ENG_MANAGEMENT]: 'Revisa laudos e relatórios',
  
  [ProviderRoles.REPORT_ANALYST]: 'Revisa checklist de inspetores',
  [ProviderRoles.MASTER_PROVIDER]: 'Gerencia usuários prestadora, cadastra/ativa inspetores',
  [ProviderRoles.PROVIDER_OPERATIONAL]: 'Agenda/acompanha/recusa inspeções, cadastra despesas',
  
  [InspectorRoles.INSPECTOR]: 'Agenda, preenche checklist, insere anexos, recusa inspeções, sugere despesas'
};